import { createFileRoute } from '@tanstack/react-router';
import { LearnArticleDetail } from '~/components/sections/LearnArticleDetail';
import { learnArticleHeadMeta, loadLearnArticle } from '~/lib/learn-article-route';

export const Route = createFileRoute('/syria/$slug')({
  loader: ({ params }) => loadLearnArticle('syria', params.slug),
  head: ({ loaderData }) => learnArticleHeadMeta(loaderData?.article),
  component: SyriaArticlePage,
});

function SyriaArticlePage() {
  const { article } = Route.useLoaderData();
  return <LearnArticleDetail key={article.fullPath} article={article} />;
}
